import { ActivityEntityName } from '../../../../entities';
import { MergeDataset, MergeSource } from '../../decorators';
import { ContactFullMergeData, ContactFullMergeSchema } from '../data/contact.full.merge.data';
import { SiteMergeData, AccountMergeData, AccountMergeSchema, SiteMergeSchema } from '../data';

@MergeDataset({
    entity: ActivityEntityName.Contact,
})
export class ContactMergeDataset {
    @MergeSource({
        schema: ContactFullMergeSchema,
    })
    contact: ContactFullMergeData;

    @MergeSource({
        schema: AccountMergeSchema,
    })
    relativeAccount: AccountMergeData

    @MergeSource({
        schema: SiteMergeSchema,
    })
    relativeSite: SiteMergeData
}